<template>
  <div class="pa-1">
    <v-img
      class="imageRow"
      :src="src"
      :height="height"
      contain
      @error="onError()"
    >
      <template v-slot:placeholder>
        <v-layout
          fill-height
          align-center
          justify-center
          ma-0
        >
          <v-progress-circular
            indeterminate
            color="primary"
          />
        </v-layout>
      </template>
    </v-img>
  </div>
</template>

<script>
import UploadService from 'Arch/services/UploadService';

const defaultProps = {
  height: '48px',
  url: '/files/',
  returnValue: false,
  errorImg: '/image-gray.png',
};

export default {
  name: 'DataTableImgRow',
  props: {
    value: {
      type: [Object, String],
      default: '',
    },
    options: {
      type: Object,
      default() {
        return defaultProps;
      },
    },
  },
  data: () => ({
    errorSrc: null,
    src: null,
  }),
  computed: {
    height() {
      return this.options.height || defaultProps.height;
    },
    errorImg() {
      if (!this.options.errorImg) {
        return defaultProps.errorImg;
      }

      return this.options.errorImg;
    },
    getValue() {
      return this.value;
    },
  },
  watch: {
    getValue: {
      immediate: true,
      handler(value) {
        if (value) {
          this.getUploadedImage();
        } else {
          this.onError();
        }
      },
    },
  },
  methods: {
    onError() {
      this.src = this.errorImg;
    },
    getUploadedImage() {
      this.loading = true;
      UploadService
        .get(this.value)
        .then((response) => {
          const reader = new FileReader();
          reader.readAsDataURL(response.data);
          reader.onload = () => {
            this.src = reader.result;
          };
        }).catch(() => {
          this.onError();
        });
    },
  },
};
</script>
<style>
.imageRow .v-responsive__content {
  width: auto !important;
}

</style>
